<template>
  <div :style="{ ...getFontSizeForChatInterface('bodyText') }">
    <div
      v-if="showBanner"
      ref="bannerRef"
      tabindex="0"
      class="banner-container"
      data-testid="banner-container"
    >
      <div class="banner-icon">
        <CloudOffline />
      </div>
      <div
        class="banner-text"
        data-testid="banner-text"
      >
        {{ textMessage }}
      </div>
    </div>
    <div
      v-if="isFormSubmissionSuccessBanner"
      ref="bannerRef"
      tabindex="0"
      class="banner-container-form"
      :style="getDynamicStyle"
    >
      <div> 
        <BaseIcon
          name="CheckCircle"
          height="20px"
          width="20px"
          fill="#008A00"
          aria-label="check icon"
        />
      </div>
      <div class="banner-form-text"> 
        {{ getFormStatus }}
      </div>
      <div onclick="handleCross"> 
        <BaseIcon
          name="CrossFill"
          height="20px"
          width="20px"
          fill="#008A00"
          aria-label="check icon"
        />
      </div>
    </div>
    <div
      v-if="isFormSubmissionErrorBanner"
      ref="bannerRef"
      tabindex="0"
      class="banner-container-form error-container"
      :style="getDynamicStyle"
    >
      <div> 
        <BaseIcon
          name="WarningAmberBlack"
          height="20px"
          width="20px"
          fill="#008A00"
          aria-label="check icon"
        />
      </div>
      <div class="banner-form-text"> 
        {{ getFormStatus }}
      </div>
      <div @click="handleCross"> 
        <BaseIcon
          name="CrossFill"
          height="20px"
          width="20px"
          fill="#008A00"
          aria-label="check icon"
        />
      </div>
    </div>
    <div
      v-if="isFormSubmissionWarningBanner"
      ref="bannerRef"
      tabindex="0"
      class="banner-container-form warning-container"
      :style="getDynamicStyle"
    >
      <div class="message-container"> 
        <BaseIcon
          name="WarningAmberBlack"
          height="20px"
          width="20px"
          fill="#F06C00"
          aria-label="check icon"
        />
        <div class="banner-form-text"> 
          {{ getFormStatus }}
        </div>
      </div>
      <div @click="handleCross"> 
        <BaseIcon
          name="CrossFill"
          height="20px"
          width="20px"
          fill="#008A00"
          aria-label="check icon"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CloudOffline from '@/views/svgs-icons/CloudOffline.vue'
import BaseIcon from '@/views/BaseIcon.vue';
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
  components: {
    CloudOffline,
    BaseIcon
  },
  mixins: [fontSizeMixin],
  props: {
    textMessage: {
      type: String,
      default: ''
    }
  },
  computed: {
    isFormSubmissionSuccessBanner() {
      return this.$store.state.formSubmissionStatus.loader === true && this.$store.state.formSubmissionStatus.status === 'success'
    },
    isFormSubmissionErrorBanner() {
      return this.$store.state.formSubmissionStatus.loader === true && this.$store.state.formSubmissionStatus.status === 'error'
    },
    isFormSubmissionWarningBanner() {
      return this.$store.state.formSubmissionStatus.loader === true && this.$store.state.formSubmissionStatus.status === 'warning'
    },
    getFormStatus() {
      return this.$store.state.formSubmissionStatus.loader === true && this.$store.state.formSubmissionStatus.text
    },
    showBanner() {
      return !this.$store.state.connectionStatus
    },
    getDynamicStyle() {
      if (this.$store.state.isChatWidgetFullScreen) {
        return {
          position: 'absolute',
          'z-index': '1000',
          width: '100%',
      }
      } else {
        return {
          position: 'absolute',
          'z-index': '1000'
        }
       }
    }
  },

  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.bannerRef;
      if (Array.isArray(el)) {
        const visible = el.find(e => e?.offsetParent !== null);
        visible?.focus?.();
      } else {
        el?.focus?.();
      }
    });
  },

    
  methods: {
    handleCross() {
      this.$store.state.formSubmissionStatus.loader = false
    }
  }

}
</script>
<style lang="scss" scoped>
  .banner-container {
    width: 100%;
    height: 32px;
    background-color: #F2F2F2;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 5px;
    animation-name: fade-out-banner;
    animation-duration: 0.5s;
  }
  .banner-text {
    font-size: inherit;
    font-weight: 600;
  }
  @keyframes fade-out-banner {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .banner-container-form {
    display: flex;
    padding: 12px 16px;
    align-items: center;
    gap: 12px;
    background: #F2F8EA;

     /* Depth 16 */
     box-shadow: 0px 6.4px 14.4px 0px rgba(0, 0, 0, 0.13), 0px 1.2px 3.6px 0px rgba(0, 0, 0, 0.10);

    justify-content: center;
    animation-name: fade-out-banner;
    animation-duration: 0.5s;
  }
  .error-container {
    background: #FCF2F2;
  }
  .message-container {
    display: flex;
    align-items: center;
    .banner-form-text {
      margin-left: 8px;
    }
  }
  .warning-container {
    background: #FEF5EC;
    border: 1px solid #F7B577;
    border-radius: 8px;
    margin: 8px;
    box-sizing: border-box;
    justify-content: space-between;
    width: 67% !important;
    left: 50%;
    transform: translate(-50%, -0%);
    @media (max-width: 480px) {
      left: unset;
      transform: unset;
      width: calc(100% - 16px) !important;
    }
  }
  .banner-form-text {
    color: var(--Standard-Grey-000000---Black, #000);
    font-feature-settings: 'clig' off, 'liga' off;

    /* SubH-Body-Links/Body Text Reg 16 */
    font-size: inherit;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
  }
</style>
